import { CONSTELLATION_IDS_CONSTS } from './LENS_CONSTANTS';

// model level I/O related defaults
export const FARM_BOUNDARY_UPSAMPLE_DEFAULT = 3;
export const CROP_PHEN_OUTPUT_VECTOR_NAME = 'crop_growth_metrics';
export const CROP_PHEN_START_DATE_INPUT_NAME = 'timerange_start';
export const CROP_PHEN_END_DATE_INPUT_NAME = 'timerange_end';
export const FOREST_BOI_START_YEAR = 2017;
export const FOREST_BOI_END_YEAR = 2023;

// Block name contanst
export const FARM_BOUNDARY_BLOCK_NAME = 'farmboundarydetection';
export const PROSAIL_BLOCK_NAME = 'cropparameter';
export const CROP_PHEN_BLOCK_NAME = 'cropphenology';
export const LULC_BLOCK_NAME = 'lulc';
export const CHANGE_DETECTION_BLOCK_NAME = 'changedetection';
export const CLOUD_GAP_MODEL_NAME = 'cloudgap';
export const OPTICAL_FUSION_MODEL_NAME = 'opticalfusion';
export const WQI_BLOCK_NAME = 'waterqualityindexmodel';
export const FOREST_BIOMASS_BLOCK_NAME = 'forestbiomass';
export const CROP_STRESS_BLOCK_NAME = 'cropstress';
export const CROP_TYPE_BLOCK_NAME = 'cropclassification';
export const GAP_FILLED_NDVI = 'gapfillndvi';
export const TREE_SPECIES_BLOCK_NAME = 'treespeciesclassification';
export const CROP_TYPE_HSI_BLOCK_NAME = 'cropclassificationhsi';
export const INDEX_BLOCK_NAME = 'indexblock';

export const MODELS_EXCLUDE_WORKFLOW = [
  // CROP_PHEN_BLOCK_NAME,
  'fastsam',
  'SegmentAnything',
  'samheavy',
  PROSAIL_BLOCK_NAME,
  CROP_TYPE_BLOCK_NAME
];

// Filter only specific models for insights
export const BLOCK_FILTER_CONSTANTS = [
  FARM_BOUNDARY_BLOCK_NAME,
  PROSAIL_BLOCK_NAME,
  CROP_PHEN_BLOCK_NAME,
  LULC_BLOCK_NAME,
  CHANGE_DETECTION_BLOCK_NAME,
  WQI_BLOCK_NAME,
  FOREST_BIOMASS_BLOCK_NAME,
  CROP_STRESS_BLOCK_NAME,
  CROP_TYPE_BLOCK_NAME,
  GAP_FILLED_NDVI
];

// filter input screens for following block only
// note: this is temporary until new design, as based on new design all models will have a dedicated input screen.
export const BLOCK_INPUT_SCREENS = [
  PROSAIL_BLOCK_NAME,
  CROP_PHEN_BLOCK_NAME,
  CHANGE_DETECTION_BLOCK_NAME
];

export const ImageLinks = {
  [LULC_BLOCK_NAME]: '/ModalsInfo/lulc-output.jpg',
  [FARM_BOUNDARY_BLOCK_NAME]: '/ModalsInfo/FarmOutput.jpg',
  [CHANGE_DETECTION_BLOCK_NAME]: '/ModalsInfo/cd_thumbnail.jpg',
  [CROP_PHEN_BLOCK_NAME]: '/ModalsInfo/crop_phen_thumbnail.jpg',
  [PROSAIL_BLOCK_NAME]: '/ModalsInfo/crop_parameter_thumbnail.jpg',
  cropstress: '/ModalsInfo/CS-output.jpg',
  [OPTICAL_FUSION_MODEL_NAME]: '/ModalsInfo/OF-input.jpg',
  [CLOUD_GAP_MODEL_NAME]: '/ModalsInfo/CG-output.jpg',
  sam: '/ModalsInfo/new-sam-thumbnail.jpg',
  principalcomponentanalysis: '/ModalsInfo/PCA-Output.jpg',
  imageclustering: '/ModalsInfo/kmeans_output.jpg',
  [WQI_BLOCK_NAME]: '/ModalsInfo/wqi-output.jpg',
  [FOREST_BIOMASS_BLOCK_NAME]: '/ModalsInfo/forest-biomas-output.jpg',
  [CROP_TYPE_BLOCK_NAME]: '/ModalsInfo/crop_type.jpg',
  [GAP_FILLED_NDVI]: '/ModalsInfo/gap_fill.jpg',
  [CROP_TYPE_HSI_BLOCK_NAME]: '/ModalsInfo/ctc_hsi.png',
  placeholder: '/ModalsInfo/placeholder-image.jpg',
  satellite: '/ModalsInfo/satellite-image.png',
  [INDEX_BLOCK_NAME]: '/ModalsInfo/index-block.png'
};

export const HYPER_SPEC_MODELS = [PROSAIL_BLOCK_NAME];
export const HYPER_SPEC_SOURCES = [
  'Pixxel-D2',
  'Shakuntala',
  'EO-01 Hyperion',
  CONSTELLATION_IDS_CONSTS.PIXXEL_D2,
  CONSTELLATION_IDS_CONSTS.SHAKUNTALA,
  CONSTELLATION_IDS_CONSTS.EO_01_HYPERION
];

export const INFERENCES_ASSET_TYPE = 'inferences';
export const VISUALISATION_ASSET_TYPE = 'layers';

export const ASSET_TYPES = [INFERENCES_ASSET_TYPE, VISUALISATION_ASSET_TYPE];

export const MODELS_ALLOWED_CHANGE_DETECTION = [
  LULC_BLOCK_NAME,
  WQI_BLOCK_NAME,
  PROSAIL_BLOCK_NAME,
  CROP_STRESS_BLOCK_NAME,
  FOREST_BIOMASS_BLOCK_NAME
];

// inference UI related constants
export const INFERENCE_STAGES = {
  inferenceList: 'list',
  inferenceInput: 'input',
  inferenceOutput: 'output',
  modeList: 'modelList'
};

export const BREADCRUMBS_STAGE_A = [
  INFERENCE_STAGES.inferenceList,
  INFERENCE_STAGES.inferenceOutput,
  INFERENCE_STAGES.modeList
];

export const BREADCRUMBS_STAGE_A_INACTIVE = [
  INFERENCE_STAGES.inferenceOutput,
  INFERENCE_STAGES.modeList
];

export const SERVICE_DATA_SOURCE = {
  atlas: 'raw_mosaic',
  inference: 'model_output'
};

export const CHANGE_DETECTION_VIEW_MODES = {
  deltaRaster: 'delta',
  categorical: 'categorical',
  compare: 'compare'
};

export const CHANGE_DETECTION_MODEL_TOOLTIP_INFO = [
  {
    id: CHANGE_DETECTION_VIEW_MODES.deltaRaster,
    description: (
      <>
        <b>Delta Mode:</b> shows a change raster and class-wise statistics. For
        discrete type assets (e.g., Land Use), it categorizes into ‘Change’ and
        ‘No-Change’. For continuous type assets (e.g., Water Quality Index), it
        displays value changes from negative to positive. Class-wise statistics
        are based on input classes, either user-created or fetched from the
        assets, to highlight changes within each class.
      </>
    )
  },
  {
    id: CHANGE_DETECTION_VIEW_MODES.categorical,
    description: (
      <>
        <b>Categorical Mode:</b> tracks class-specific changes spatially and
        statistically, showing how one class transforms into others (e.g.,
        forest to barren land), aiding in decision-making.
      </>
    )
  },
  {
    id: CHANGE_DETECTION_VIEW_MODES.compare,
    description: (
      <>
        <b>Compare Mode:</b> offers opacity adjustments for subtle comparisons
        and split view for side-by-side image analysis to identify the change.
      </>
    )
  }
];

export const COLOR_LEGEND_MAP_RASTER_NAME = {
  [CHANGE_DETECTION_VIEW_MODES.deltaRaster]: 'delta_raster'
};

export const VIEWMODE_MAP_RASTER_NAME = {
  [CHANGE_DETECTION_VIEW_MODES.deltaRaster]: 'delta_raster'
  // not relevant for split mode
  // [CHANGE_DETECTION_VIEW_MODES.categorical]: 'categorical_raster'
};

export const MODELS_ACCEPTED_SPLIT = [
  FOREST_BIOMASS_BLOCK_NAME,
  WQI_BLOCK_NAME,
  PROSAIL_BLOCK_NAME,
  CROP_STRESS_BLOCK_NAME,
  LULC_BLOCK_NAME
];

// water quality index model constants
export const WQI_RASTER_NAMES = {
  aCDOM: 'acdom_raster',
  chlA: 'chl_raster',
  turbudityIndex: 'ti_raster',
  cDom: 'ci_raster',
  tropicStateInd: 'tsi_raster',
  wqIndex: 'wqi_raster',
  turbudityRaster: 'tss_raster'
};

export const WQI_EXCLUDE_RASTERS = ['masked_reflectance_raster'];

export const WQI_AREA_INFO =
  'Transparent area signifies either no water area or insufficient data in that area for model to run';
export const FOREST_AREA_INFO =
  'Transparent area signifies either no forest area or insufficient data in that area for model to run';
export const LULC_AREA_INFO = 'Transparent area signifies pixels with no data';
export const PROSAIL_AREA_INFO =
  'Transparent area signifies either pixels with no data or pixels having NDVI value less than 0.2';
export const CROPS_STRESS_AREA_INFO =
  'Transparent area signifies either no crop area or insufficient data in that area for model to run';
export const PROSAIL_GRAPH_INFO =
  'Area percentage denoted in the graph is a percentage of total area having NDVI > 0.2 and not of the AOI.';
export const TREE_SPECIES_AREA_INFO =
  'Transparent area signifies either non tree area or insufficient data in that area for model to run';
export const CROP_TYPE_HSI_AREA_INFO =
  'Transparent area signifies either non crop area or insufficient data in that area for model to run';

export const WQI_LIST = {
  [`${WQI_RASTER_NAMES.wqIndex}`]: {
    title: <>WQI</>,
    name: <>Water Quality Index</>,
    csv_name: 'wqi_csv',
    src: '/images/wqi_thumb.jpg',
    info: (
      <>
        Water quality refers to the chemical, physical, and biological
        characteristics of water. Water quality is assessed using suitable
        mathematical/computational models to predict the behavior of specific
        water quality parameters in a water body.
      </>
    ),
    isLog: false
  },
  [`${WQI_RASTER_NAMES.tropicStateInd}`]: {
    title: <>TSI</>,
    name: <>Trophic State Index</>,
    csv_name: 'tsi_csv',
    src: '/images/tsi_thumb.jpg',
    info: <>Trophic State Index (TSI) is a normalized version of Chl-a</>,
    isLog: false
  },
  [`${WQI_RASTER_NAMES.cDom}`]: {
    title: <>CI</>,
    name: <>CDOM Index</>,
    csv_name: 'ci_csv',
    src: '/images/cdom_thumb.jpg',
    info: (
      <>
        CDOM Index (CI) is a normalized version of a<sub>CDOM</sub>
      </>
    ),
    isLog: false
  },
  [`${WQI_RASTER_NAMES.turbudityIndex}`]: {
    title: <>TI</>,
    name: <>TSS Index</>,
    csv_name: 'ti_csv',
    src: '/images/ti_thumb.jpg',
    info: <>TSS Index (TI) is a normalized version of TSS</>,
    isLog: false
  },
  // TODO: the below parameters do not support current colorscale implementation, hence commented out,
  // until end to end solution figure out from model end
  [`${WQI_RASTER_NAMES.chlA}`]: {
    title: <>Chl-a</>,
    name: <>Chlorophyll-a</>,
    csv_name: 'chl_csv',
    src: '/images/chl_thumb.jpg',
    info: (
      <>
        Chl-a (Chlorophyll-a) is a measure of the amount of chlorophyll-a
        pigment present in water bodies. Chlorophyll-a is a pigment found in
        algae and plants, and its concentration in water indicates the level of
        algal growth or biomass.High levels of Chl-a can indicate the presence
        of excessive algae , which may lead to water quality issues such as
        excessive nutrient enrichment, reduced oxygen levels, and harmful algal
        blooms.
      </>
    ),
    isLog: true
  },
  [`${WQI_RASTER_NAMES.aCDOM}`]: {
    title: (
      <>
        a<sub>CDOM</sub>(440)
      </>
    ),
    name: (
      <>Absorption coefficient of Colored Dissolved Organic Matter at 440 nm</>
    ),
    csv_name: 'acdom_csv',
    src: '/images/acdom_thumb.jpg',
    info: (
      <>
        a<sub>CDOM</sub> (Absorption of Colored Dissolved Organic Matter)
        measures the absorption of colored dissolved organic matter in water.
        Colored dissolved organic matter is composed of organic compounds from
        decaying plant and animal matter that can affect water clarity and
        quality.High levels of a<sub>CDOM</sub> can indicate organic pollution
        in water bodies, which may be caused by factors such as agricultural
        runoff, urban runoff, or wastewater discharge. Elevated a<sub>CDOM</sub>{' '}
        levels can reduce water transparency and affect aquatic ecosystems.
      </>
    ),
    isLog: true
  },
  [`${WQI_RASTER_NAMES.turbudityRaster}`]: {
    title: <>TSS</>,
    name: <>Total Suspended Solids</>,
    csv_name: 'tss_csv',
    src: '/images/ti_thumb.jpg',
    info: (
      <>
        TSS refers to the concentration of suspended particles in water,
        including silt, sediment, and organic matter. It is an important
        indicator of water clarity and quality. High TSS levels can suggest soil
        erosion, sediment runoff, or pollution from anthropogenic activities.
        Elevated TSS can reduce sunlight penetration in the water, hinder the
        growth of aquatic plants, and affect the ability of aquatic organisms to
        locate food.
      </>
    ),
    isLog: true
  }
};

// Forest biomas contants
export const FOREST_BIO_GRAPH_NAME = 'fagb_stats_csv_path';
// CROP STRESS CONSTANTS
export const CROP_STRESS_GRAPH_OUTPUT_NAME = 'result_stats';
// LULC model constants
export const LULC_GRAPH_OUTPUT_NAME = 'result_stats';
// crop phen constants
export const CROP_PHEN_GRAPH_NAME = 'crop_growth_metrics_json';
// tree species constants
export const TREE_SPECIES_GRAPH_OUTPUT_NAME = 'species_statistics';
// crop type hsi constants
export const CROP_TYPE_HSI_GRAPH_OUTPUT_NAME = 'stats_output';

// Prosail (Crop Parameter) constants
export const PROSAIL_RASTER_NAMES = {
  lai_raster: 'lai_raster',
  chl_raster: 'chl_raster',
  bp_raster: 'bp_raster',
  wt_raster: 'wt_raster',
  car_raster: 'car_raster',
  dw_raster: 'dw_raster'
};

export const PROSAIL_PARAMS = {
  [PROSAIL_RASTER_NAMES.lai_raster]: {
    title: 'LAI (Leaf Area Index)',
    name: '',
    csv_name: 'comp_csv_lai',
    stats_name: 'stats_csv_lai',
    src: '/images/wqi_thumb.jpg',
    info: 'LAI is a measure of the total area of leaves per unit ground area. It indicates the density and coverage of leaves in a specific area of vegetation.'
  },
  [PROSAIL_RASTER_NAMES.chl_raster]: {
    title: 'Chlorophyll content',
    name: '',
    csv_name: 'comp_csv_chlorophyll',
    stats_name: 'stats_csv_chlorophyll',
    src: '/images/tsi_thumb.jpg',
    info: 'Chlorophyll is a green pigment found in plants that plays a crucial role in photosynthesis, the process by which plants convert sunlight into energy.'
  },
  [PROSAIL_RASTER_NAMES.bp_raster]: {
    title: 'Brown Pigment Indication',
    name: '',
    csv_name: 'comp_csv_brown_pigment',
    stats_name: 'stats_csv_brown_pigment',
    src: '/images/cdom_thumb.jpg',
    info: 'Brown pigments in plants can vary and may include compounds such as tannins or melanins. These pigments contribute to plant coloration and can have various biological functions.'
  },
  [PROSAIL_RASTER_NAMES.wt_raster]: {
    title: 'Water Thickness',
    name: '',
    csv_name: '',
    stats_name: 'stats_csv_water_thickness',
    src: '/images/ti_thumb.jpg',
    info: 'Water thickness refers to the amount or depth of water absorbed or retained by plant tissues, such as leaves or stems.'
  },
  [PROSAIL_RASTER_NAMES.car_raster]: {
    title: 'Carotenoids',
    name: '',
    csv_name: '',
    stats_name: 'stats_csv_carotenoid',
    src: '/images/chl_thumb.jpg',
    info: 'Carotenoids are pigments responsible for the yellow, orange, and red colors in plants. They play a role in photosynthesis and antioxidant protection'
  },
  [PROSAIL_RASTER_NAMES.dw_raster]: {
    title: 'Dry Weight',
    name: '',
    csv_name: '',
    stats_name: 'stats_csv_dry_weight',
    src: '/images/acdom_thumb.jpg',
    info: 'Dry weight refers to the weight of plant material (leaves, stems, roots) after removing all moisture. It is a measure of biomass or the amount of plant tissue'
  }
};

export const PARAMETER_MODELS = [WQI_BLOCK_NAME, PROSAIL_BLOCK_NAME];
export const MODELWISE_PARAMETER_DICT = {
  [WQI_BLOCK_NAME]: {
    ...WQI_LIST
  },
  [PROSAIL_BLOCK_NAME]: {
    ...PROSAIL_PARAMS
  }
};

export const DISCRETISATION_TYPES = {
  bucket: 'interval',
  discrete: 'index'
};
